/** 通用 UI 无障碍文案 — 18 语言 */
export const uiChromeTranslations = {
  zh: {
    uiClose: "关闭",
    carouselPrev: "上一个产品",
    carouselNext: "下一个产品",
    heroSlidePrev: "上一张",
    heroSlideNext: "下一张",
    heroSlideDot: "切换到第{n}张",
  },
  en: {
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
  },
  de: {
    uiClose: "Schließen",
    carouselPrev: "Vorheriges Produkt",
    carouselNext: "Nächstes Produkt",
    heroSlidePrev: "Vorherige Folie",
    heroSlideNext: "Nächste Folie",
    heroSlideDot: "Zur Folie {n}",
  },
  pt: {
    uiClose: "Fechar",
    carouselPrev: "Produto anterior",
    carouselNext: "Próximo produto",
    heroSlidePrev: "Slide anterior",
    heroSlideNext: "Próximo slide",
    heroSlideDot: "Ir para o slide {n}",
  },
  es: {
    uiClose: "Cerrar",
    carouselPrev: "Producto anterior",
    carouselNext: "Producto siguiente",
    heroSlidePrev: "Diapositiva anterior",
    heroSlideNext: "Diapositiva siguiente",
    heroSlideDot: "Ir a la diapositiva {n}",
  },
  fr: {
    uiClose: "Fermer",
    carouselPrev: "Produit précédent",
    carouselNext: "Produit suivant",
    heroSlidePrev: "Diapositive précédente",
    heroSlideNext: "Diapositive suivante",
    heroSlideDot: "Aller à la diapositive {n}",
  },
  it: {
    uiClose: "Chiudi",
    carouselPrev: "Prodotto precedente",
    carouselNext: "Prodotto successivo",
    heroSlidePrev: "Slide precedente",
    heroSlideNext: "Slide successiva",
    heroSlideDot: "Vai alla slide {n}",
  },
  hi: {
    uiClose: "बंद करें",
    carouselPrev: "पिछला उत्पाद",
    carouselNext: "अगला उत्पाद",
    heroSlidePrev: "पिछली स्लाइड",
    heroSlideNext: "अगली स्लाइड",
    heroSlideDot: "स्लाइड {n} पर जाएँ",
  },
  ru: {
    uiClose: "Закрыть",
    carouselPrev: "Предыдущий продукт",
    carouselNext: "Следующий продукт",
    heroSlidePrev: "Предыдущий слайд",
    heroSlideNext: "Следующий слайд",
    heroSlideDot: "Перейти к слайду {n}",
  },
  ko: {
    uiClose: "닫기",
    carouselPrev: "이전 제품",
    carouselNext: "다음 제품",
    heroSlidePrev: "이전 슬라이드",
    heroSlideNext: "다음 슬라이드",
    heroSlideDot: "{n}번째 슬라이드로 이동",
  },
  ja: {
    uiClose: "閉じる",
    carouselPrev: "前の製品",
    carouselNext: "次の製品",
    heroSlidePrev: "前のスライド",
    heroSlideNext: "次のスライド",
    heroSlideDot: "{n}枚目のスライドへ",
  },
  th: {
    uiClose: "ปิด",
    carouselPrev: "สินค้าก่อนหน้า",
    carouselNext: "สินค้าถัดไป",
    heroSlidePrev: "สไลด์ก่อนหน้า",
    heroSlideNext: "สไลด์ถัดไป",
    heroSlideDot: "ไปที่สไลด์ที่ {n}",
  },
  tr: {
    uiClose: "Kapat",
    carouselPrev: "Önceki ürün",
    carouselNext: "Sonraki ürün",
    heroSlidePrev: "Önceki slayt",
    heroSlideNext: "Sonraki slayt",
    heroSlideDot: "{n}. slayta git",
  },
  vi: {
    uiClose: "Đóng",
    carouselPrev: "Sản phẩm trước",
    carouselNext: "Sản phẩm tiếp",
    heroSlidePrev: "Trang trước",
    heroSlideNext: "Trang sau",
    heroSlideDot: "Chuyển đến trang {n}",
  },
  nl: {
    uiClose: "Sluiten",
    carouselPrev: "Vorig product",
    carouselNext: "Volgend product",
    heroSlidePrev: "Vorige dia",
    heroSlideNext: "Volgende dia",
    heroSlideDot: "Ga naar dia {n}",
  },
  id: {
    uiClose: "Tutup",
    carouselPrev: "Produk sebelumnya",
    carouselNext: "Produk berikutnya",
    heroSlidePrev: "Slide sebelumnya",
    heroSlideNext: "Slide berikutnya",
    heroSlideDot: "Ke slide {n}",
  },
  ar: {
    uiClose: "إغلاق",
    carouselPrev: "المنتج السابق",
    carouselNext: "المنتج التالي",
    heroSlidePrev: "الشريحة السابقة",
    heroSlideNext: "الشريحة التالية",
    heroSlideDot: "الانتقال إلى الشريحة {n}",
  },
  pl: {
    uiClose: "Zamknij",
    carouselPrev: "Poprzedni produkt",
    carouselNext: "Następny produkt",
    heroSlidePrev: "Poprzedni slajd",
    heroSlideNext: "Następny slajd",
    heroSlideDot: "Przejdź do slajdu {n}",
  },
};
